import { Outlet } from "react-router-dom"

export default function FlashcardsPage() {
  return (
    <section className="z-5 absolute left-0 top-0 flex size-full flex-col gap-4 lg:flex-row lg:gap-8">
      <Outlet />
    </section>
  )
}
